import moment from 'moment'

// test: jest src/utils/booking/__tests__/LeadTime.test.js
export default class LeadTime {
  constructor() {
    this.leadDays = null
    this.leadMinutes = null
  }

  setLeadDays(days) {
    this.leadDays = days
  }

  setLeadMinutes(minutes) {
    this.leadMinutes = minutes
  }

  isAvailable(targetTime, currentTime) {
    const target = moment(targetTime)
    const current = moment(currentTime)

    // 沒有設定好的話就預設通過
    if ([this.leadDays, this.leadMinutes].every(value => [0, null].includes(value))) {
      return true
    }

    if (this.leadDays) {
      const diffInDays = target.startOf('day').diff(current.startOf('day'), 'days')
      return diffInDays >= this.leadDays
    }

    if (this.leadMinutes) {
      const diffInMinutes = target.startOf('minute').diff(current.startOf('minute'), 'minutes')
      return diffInMinutes >= this.leadMinutes
    }

    return true
  }
}
